// ============================================================
// 打印版式配置（所有单据均按 A4 纸打印）
// 需要调整打印版式时，只改这里即可，无需动业务代码。
//
// marginTop / marginBottom：页面上下留白（mm）
// marginX：页面左右留白（mm）——左右两侧始终一致
// fontSize：正文基础字号（px）——单据内部元素均按 em 等比缩放，
//           整体放大 / 缩小只需要调这个值
// ============================================================

// A4 纸张尺寸（mm）
const A4 = {
  portrait: { width: 210, height: 297 }, // 纵向
  landscape: { width: 297, height: 210 }, // 横向
};

// 个人费用报销检验回执单（A4 纵向）
export const receipt = {
  landscape: false,
  marginTop: 10,
  marginBottom: 10,
  marginX: 10,
  fontSize: 19,
};

// 费用报销单（A4 横向）
export const expense = {
  landscape: true,
  marginTop: 9,
  marginBottom: 5,
  marginX: 18,
  fontSize: 19,
};

/**
 * 单页内容区可用高度（mm）= 纸张高度 - 上下留白
 * 用于把报销单的底部区块（商务性支出 → 备注）顶到页面最下方
 */
export function contentHeight(cfg) {
  return (cfg.landscape ? A4.landscape : A4.portrait).height - cfg.marginTop - cfg.marginBottom;
}

export default { receipt, expense, contentHeight };
